import { Link } from "react-router-dom";
import type { LiveItem } from "@/mocks/lives";
import { formatViewers, getCategoryLabel } from "@/utils/live";
import StatusBadge from "./StatusBadge";

interface LiveCardProps {
  item: LiveItem;
  className?: string;
}

export default function LiveCard({ item, className = "" }: LiveCardProps) {
  return (
    <Link
      to={`/live/${item.id}`}
      className={`group flex flex-col overflow-hidden rounded-lg border border-background-200/60 bg-background-100 transition-colors duration-300 hover:border-primary-500/60 ${className}`}
    >
      <div className="relative aspect-video w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.streamer} 直播 ${item.title}`}
          title={`${item.title} - 360直播`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent" />
        <div className="absolute left-3 top-3">
          <StatusBadge status={item.status} />
        </div>
        <div className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-background-50/75 px-2 py-1 text-[11px] font-medium text-foreground-900 backdrop-blur-sm">
          <i className="ri-eye-line text-xs" />
          {item.status === "live" ? formatViewers(item.viewers) : "预约"}
        </div>
        <div className="absolute bottom-3 left-3 flex items-center gap-1.5 rounded-md bg-background-50/75 px-2 py-1 text-[11px] font-medium text-foreground-900 backdrop-blur-sm">
          <i className="ri-hd-line text-xs text-primary-300" />
          {item.resolution}
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-3 p-4">
        <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-300">
          {item.title}
        </h3>
        <div className="mt-auto flex items-center justify-between gap-3">
          <div className="flex min-w-0 items-center gap-2">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-500/15 font-label text-xs font-bold text-primary-300">
              {item.streamer.slice(0, 1)}
            </span>
            <span className="truncate text-xs text-foreground-600">{item.streamer}</span>
          </div>
          <span className="shrink-0 rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
            {getCategoryLabel(item.category)}
          </span>
        </div>
      </div>
    </Link>
  );
}